import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import "../styles/HomePage.css";
import ss from "../assets/images/SS.png";
import { useNavigate } from "react-router-dom";
import SchemeRegistration from "../../src/components/Master/SchemeRegistration/SchemeRegistration";
import SchemeManagement from "../../src/components/Master/SchemeManagement/SchemeManagement";

import SchemeCashReceipt from "../components/Entry/SchemeReceipt/SchemeCashReceipt";
import MenuBar from "../components/NavBars/MenuBar";
import SchemeRedeem from "../components/Entry/SchemeRedeem/SchemeRedeem";
import SchemeReport from "../components/AccountReports/SchemeReports/SchemeReport";
import SchemeReportDialog from "../components/AccountReports/SchemeReports/SchemeReportDia";

import close from "../assets/images/close.png";
import {
  FiFileText,
  FiBookOpen,
  FiUsers,
  FiGift,
  FiBarChart2,
  FiSettings,
  FiPower,
  FiFile,
} from "react-icons/fi";
import { FaRupeeSign } from "react-icons/fa";

import ComboBox from "../../src/components/ComboBoxes/ComboBox";
import axios from "axios";
import LedgerReg from "../components/Master/AccountRegistration/LedgerRegistration/LedgerReg";
import OtherRegistration from "../components/Master/OtherRegistartion/OtherRegistration/OtherRegistration";
import CustomerAppReg from "../components/Master/CustomerAppRegistration/CustomerAppReg";
import AppBroadcastManager from "../components/Master/AppBroadcastManager/AppBroadcastManager";
import AppConfigMaster     from "../components/Master/AppConfigMaster/AppConfigMaster";
import InvoiceDesigner     from "../components/Tools/InvoiceDesigner/InvoiceDesigner";
import PrintModelAssigner  from "../components/Tools/PrintModelAssigner/PrintModelAssigner";
import StaffReg from "../components/Master/OtherRegistartion/StaffRegistration/StaffReg";
import RateClassReg from "../components/Master/OtherRegistartion/RateclassRegistration/RateClassReg";
import StockGroupReg from "../components/Master/OtherRegistartion/StockGroupRegistration/StockGroupReg";
import ModelReg from "../components/Master/OtherRegistartion/ModelRegistration/ModelReg";
import RateSettings from "../components/Master/RateSettings/RateSettings";
import { AuthContext } from "../context/AuthContext";
import ReceiptList from "../components/AccountReports/ReceiptList/ReceiptList";
import "../styles/primaryNavbar.css";
import ReceiptListReport from "../components/AccountReports/ReceiptList/ReceiptListReport";
import FormRegistration from "../components/File/FormRegistration/FormRegistration";
import DayBook from "../components/AccountReports/DayBook/DayBook";
import DayBookReport from "../components/AccountReports/DayBook/DayBookReport";
import JournalEntry from "../components/Entry/JournalEntry/JournalEntry";
import ContraEntry from "../components/Entry/ContraEntry/ContraEntry";
import LedgerRepModel from "../components/AccountReports/LedgerReport/LedgerRepModel";
import LedgerReport from "../components/AccountReports/LedgerReport/LedgerReport";
import QuickSearch from "../components/QuickSearch";
import AgentReportModel from "../components/AccountReports/AgentReport/AgentReportModel";
import AgentReport from "../components/AccountReports/AgentReport/AgentReport";
import { useDbContext } from "../context/DbContext";
import SmsSettings from "../components/SmsSettings";
import WhatsAppSettings from "../components/WhatsAppSettings";
import PaymentGatewaySettings from "../components/Master/PaymentGatewaySettings/PaymentGatewaySettings";
import CashReceipt from "../components/Entry/Receipt/CashReceipt";
import CashPayment from "../components/Entry/Payment/CashPayment";

import LedgerList from "../components/RecordList/LedgerList/LedgerList";
import io from "socket.io-client";
import ProductReg from "../components/Master/ProductRegistration/ProductReg";
import SchemeOverDue from "../components/RecordList/SchemeOverDueList/SchemeOverDue";
import PurchaseEntry from "../components/Entry/Purchase/PurchaseEntry";
import rclose from "../assets/images/findclose.png";
import headeLogo from "../assets/images/shersoftnavLogo.png";
import EventDetails from "../components/RecordList/EventDetails/EventDetails";
import PurchaseListDialog from "../components/InventoryReports/PurchaseList/PurchaseListDialog";
import PurchaseList from "../components/InventoryReports/PurchaseList/PurchaseList";
import EventDetailsReport from "../components/RecordList/EventDetails/EventDetailsReport";
import CreateUser from "../components/Master/CreateUser/CreateUser";
import { useSelector, useDispatch } from "react-redux";
import { selectMenuPermissions } from "../app/permissionsSlice";
import { fetchActiveFinancialYear } from "../app/financialYearSlice";
import { fetchActiveLocation } from "../app/locationSlice";
import ProgressBar from "../components/ProgressBars/ProgressBar";
import BackupLoader from "../components/shared/BackupLoader";
import SoftWareSettings from "../components/Tools/SoftwareSettings/SoftwareSettingsRoot/SoftWareSettings";
import SettingsListener from "../components/SocketListeners/SettingsListener";
import FinancialYear from "../components/File/FinancialYearRegistration/FinancialYear";
import PasswordVerification from "../components/verificators/PasswordVerification";
import GroupRegistration from "../components/Master/AccountRegistration/GroupRegistration/GroupRegistration";
import GroupList from "../components/AccountReports/GroupList/GroupList";
import GroupListReport from "../components/AccountReports/GroupList/GroupListReport";
import Sidebar from "../components/Layout/Sidebar/Sidebar";
import StatusBar from "../components/Layout/StatusBar/StatusBar";
import MarqueeNotice from "../components/Layout/MarqueeNotice/MarqueeNotice";
import LiveRateCard from "../components/Layout/LiveRateCard/LiveRateCard";
function HomePage() {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [isLoading, setIsLoading] = useState(true);
  const permissions = useSelector(selectMenuPermissions);
  const { logout, agentCode } = useContext(AuthContext);
  const { dbCode } = useDbContext();
  const [userType, setuserType] = useState("");
  const [userCode, setuserCode] = useState("");
  const [userAccno, setuserAccno] = useState("");
  const [cashRecFormInfo, setCashRecFormInfo] = useState({
    id: "",
    name: "",
    voucherType: "",
  });
  const [cashPayFormInfo, setCashPayFormInfo] = useState({
    id: "",
    name: "",
    voucherType: "",
  });
  const [purchaseFormInfo, setPurchaseFormInfo] = useState({
    id: "",
    name: "",
  });
  const [receiptFormInfo, setReceiptFormInfo] = useState({ id: "", name: "" });
  const [redeemFormInfo, setRedeemFormInfo] = useState({
    id: "",
    name: "",
    voucherType: "",
  });
  const [jvFormInfo, setJvFormInfo] = useState({
    id: "",
    name: "",
    voucherType: "JOURNAL",
  });
  const [cvFormInfo, setCvFormInfo] = useState({
    id: "",
    name: "",
    voucherType: "CONTRA",
  });
  const navigate = useNavigate();
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [backupBytesLoaded, setBackupBytesLoaded] = useState(0);
  const [backupStatus, setBackupStatus] = useState("idle");
  const [backupError, setBackupError] = useState("");

  useEffect(() => {
    setZIndices((prev) => ({ ...prev, initialModal: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowModal(true);
  }, []);

  useEffect(() => {
    const storeduType = sessionStorage.getItem("userType");
    if (storeduType) {
      setuserType(storeduType);
      if (storeduType === "CUSTOMERS") {
        const customers = sessionStorage.getItem("CustomerName");
        const accno = sessionStorage.getItem("Uaccno");
        setuserCode(customers);
        setuserAccno(accno);
      }
    }
  }, []);
  const dispatch = useDispatch();

  useEffect(() => {
    if (dbCode) {
      dispatch(fetchActiveFinancialYear(dbCode));
      dispatch(fetchActiveLocation(dbCode));
    }
  }, [dbCode, dispatch]);

  useEffect(() => {
    const storedAgentCode = sessionStorage.getItem("agentCode");
    const storedDbCode = localStorage.getItem("dbCode");
    if (!storedAgentCode || !storedDbCode) {
      navigate("/login");
    }
  }, [navigate]);
  const [cRate, setCrate] = useState("");
  useEffect(() => {
    const fetchSchCurrentRate = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/getGoldRate/${dbCode}`,
        );
        const currentrate = response.data[0]?.currentRate;
        setCrate(currentrate);
      } catch (error) {
        console.error("Error fetching gold rate:", error.message);
      }
    };
    fetchSchCurrentRate();
  }, [apiBaseUrl, dbCode]);
  const [showGoldCaratDropdown, setShowGoldCaratDropdown] = useState(false);
  const [realTimeGoldRate, setRealTimeGoldRate] = useState("");
  useEffect(() => {
    const fetchRealTimeGoldRate = async () => {
      try {
        const response = await axios.get(
          `https://api.metalpriceapi.com/v1/latest?api_key=${process.env.REACT_APP_METALPRICEAPI_KEY}&base=INR&currencies=XAU`,
        );
        if (response.data.success) {
          const pricePerOunce = response.data.rates.XAU;
          const pricePerGram = (pricePerOunce / 31.1034768).toFixed(2);
          setRealTimeGoldRate(pricePerGram);
        } else {
          throw new Error(
            response.data.error?.info || "API response unsuccessful",
          );
        }
      } catch (error) {
        // console.error(
        //   "Error fetching real-time gold rate from MetalpriceAPI:",
        //   error.message
        // );
        setRealTimeGoldRate("N/A");
      }
    };
    fetchRealTimeGoldRate();
    const interval = setInterval(fetchRealTimeGoldRate, 300000);
    return () => clearInterval(interval);
  }, [apiBaseUrl, dbCode]);
  const calculateCaratPrices = (goldRate24k) => {
    if (!goldRate24k || goldRate24k === "N/A" || isNaN(goldRate24k)) {
      return { k22: "N/A", k18: "N/A" };
    }
    const price24k = parseFloat(goldRate24k);
    const k22Price = (price24k * (22 / 24)).toFixed(2); // 22k = 91.67% of 24k
    const k18Price = (price24k * (18 / 24)).toFixed(2); // 18k = 75% of 24k
    return { k22: k22Price, k18: k18Price };
  };
  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [ReportData, setReportData] = useState({
    fromDate: getCurrentDate(),
    toDate: getCurrentDate(),
    reportType: "simpleReport",
    agent: "",
    customer: "",
    mobileNo: "",
    accno: "",
  });

  const handleClear = () => {
    setReportData({
      ...ReportData,
      fromDate: getCurrentDate(),
      toDate: getCurrentDate(),
      reportType: "simpleReport",
      customer: "",
      mobileNo: "",
      accno: "",
    });
    if (userType === "CUSTOMERS") {
      reportAgent();
    }
  };

  const [modalCounter, setModalCounter] = useState(1000);
  const [zIndices, setZIndices] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showNotification, setShowNotification] = useState(true);
  const [animateNotification, setAnimateNotification] = useState(false);

  useEffect(() => {
    setShowModal(true);
    const timer = setTimeout(() => {
      setAnimateNotification(true);
    }, 150);
    return () => clearTimeout(timer);
  }, []);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [showschManagmentModal, setShowschManagmentModal] = useState(false);

  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showStaffRegModal, setShowStaffRegModal] = useState(false);
  const [showRateClassModal, setShowRateClassModal] = useState(false);
  const [showStockGroupModal, setShowStockGroupModal] = useState(false);
  const [showModelRegModal, setShowModelRegModal] = useState(false);
  const [showRateSettingsModal, setShowRateSettingsModal] = useState(false);
  const [showReceiptListModal, setShowReceiptListModal] = useState(false);
  const [showReceiptListReportModal, setShowReceiptListReportModal] =
    useState(false);
  const [showFormRegModal, setShowFormRegModal] = useState(false);
  const [showdayBookModal, setDayBookModal] = useState(false);
  const [showdayBookReportModal, setDayBookReportModal] = useState(false);
  const [showjvModal, setJvModal] = useState(false);
  const [showcvModal, setCvModal] = useState(false);
  const [showledgerdiaModal, setledgerdiaModal] = useState(false);
  const [showledgerReportModal, setledgerReportModal] = useState(false);
  const [showqSearchModal, setQsearchModal] = useState(false);
  const [showagReportdiaModal, setShowagReportdiaModal] = useState(false);
  const [showagReportModal, setShowagReportModal] = useState(false);
  const [showeventDetailsModal, setShoweventDetailsModal] = useState(false);
  const [showeventRepModal, setShoweventRepModal] = useState(false);
  const [showSmssettingsModal, setShowSmssettingsModal] = useState(false);
  const [showwhatsappsettingsModal, setShowwhatsappsettingsModal] =
    useState(false);
  const [showPaymentGatewaySettingsModal, setShowPaymentGatewaySettingsModal] =
    useState(false);
  const [showcashRecModal, setShowCashRecModal] = useState(false);
  const [showcashPayModal, setShowCashPayModal] = useState(false);
  const [showPurchaseEntyModal, setShowPurchaseEntyModal] = useState(false);
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [showLedgerListModal, setShowLedgerListModal] = useState(false);
  const [showoverDueListModal, setShowOverDueListModal] = useState(false);
  const [showproductRegModal, setShowProductRegModal] = useState(false);
  const [showPurchaseListModal, setShowPurchaseListModal] = useState(false);
  const [showPurchaseListReportModal, setShowPurchaseListReportModal] =
    useState(false);
  const [purchaseListPayload, setPurchaseListPayload] = useState(null);
  const [schemeReportPayload, setSchemeReportPayload] = useState(null);

  const [showFinancialYearModal, setShowFinancialYearModal] = useState(false);
  const [showFyPasswordModal, setShowFyPasswordModal] = useState(false);

  // Payload state for GroupList
  const [groupListPayload, setGroupListPayload] = useState(null);

  const openFy = () => {
    setZIndices((prev) => ({ ...prev, fy: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowFyPasswordModal(true);
  };

  const handleFyPasswordSuccess = () => {
    setShowFyPasswordModal(false);
    setShowFinancialYearModal(true);
  };

  const opencashRec = (frmId, fname, voucherType) => {
    setCashRecFormInfo({ id: frmId, name: fname, voucherType });
    setZIndices((prev) => ({ ...prev, cashRec: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowCashRecModal(true);
  };

  const opencashPay = (frmId, fname, voucherType) => {
    setCashPayFormInfo({ id: frmId, name: fname, voucherType });
    setZIndices((prev) => ({ ...prev, cashPay: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowCashPayModal(true);
  };

  const openPEntry = (frmId, fname, voucherType) => {
    setPurchaseFormInfo({ id: frmId, name: fname, voucherType });
    setZIndices((prev) => ({ ...prev, purchaseEntry: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowPurchaseEntyModal(true);
  };

  const openGoldReceipt = (frmId, fname, voucherType) => {
    setPurchaseFormInfo({ id: frmId, name: fname, voucherType });
    setZIndices((prev) => ({ ...prev, purchaseEntry: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowPurchaseEntyModal(true);
  };

  const openSmsSettings = () => {
    setZIndices((prev) => ({ ...prev, smsSettings: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowSmssettingsModal(true);
  };

  const openwhatsAppSettings = () => {
    setZIndices((prev) => ({ ...prev, whatsAppSettings: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowwhatsappsettingsModal(true);
  };

  const openPaymentGatewaySettings = () => {
    setZIndices((prev) => ({ ...prev, paymentGatewaySettings: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowPaymentGatewaySettingsModal(true);
  };

  const openCreateUserModal = () => {
    setZIndices((prev) => ({ ...prev, createUser: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowCreateUserModal(true);
  };

  const openagReportdiaModal = (e) => {
    setZIndices((prev) => ({ ...prev, agReportDia: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowagReportdiaModal(true);
  };

  const openAgreport = (agdata) => {
    setZIndices((prev) => ({ ...prev, agReport: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setAgreportData(agdata);
    setShowagReportModal(true);
  };

  const openEventModal = (e) => {
    setZIndices((prev) => ({ ...prev, eventRep: modalCounter }));
    setModalCounter((prev) => prev + 100);
    seteventData(null);
    setShoweventRepModal(true);
  };

  const openEventReport = (data) => {
    setZIndices((prev) => ({ ...prev, eventRep: modalCounter }));
    setModalCounter((prev) => prev + 100);
    seteventData(data);
    setShoweventRepModal(true);
  };

  const openRegistrationModal = (actionPermissions = {}, name = "") => {
    const isString = typeof actionPermissions === "string";
    const initialName = isString ? actionPermissions : "";
    const initialScheme = isString && name && typeof name === "object" ? name : null;
    setSchemeRegInitialName(initialName);
    setSchemeRegInitialScheme(initialScheme);

    setZIndices((prev) => ({ ...prev, registration: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowRegistrationModal(true);
  };

  const openSchmanagementModal = (actionPermissions = {}) => {
    setZIndices((prev) => ({ ...prev, schManagement: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowschManagmentModal(true);
  };

  const [ledgerListInitialParent, setLedgerListInitialParent] = useState(null);

  const openLedgerListModal = (parent = null) => {
    setZIndices((prev) => ({ ...prev, ledgerList: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setLedgerListInitialParent(parent);
    setShowLedgerListModal(true);
  };

  const openoverDueListModal = () => {
    setZIndices((prev) => ({ ...prev, overDueList: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowOverDueListModal(true);
  };

  const [ledval, setLedval] = useState("");
  const [schMgName, setSchMgName] = useState("");
  const [PrdValue, setPrdValue] = useState("");
  const [under, setUnder] = useState("");
  const [trackbackRowIndex, setTrackbackRowIndex] = useState("");
  const [trackbackColIndex, setTrackbackColIndex] = useState("");

  // -------------------Account Registration-----------------------------

  // 1.LEDGER REGISTRATION

  const [showLedgerRegModal, setShowLedgerRegModal] = useState(false);
  const [showOtherRegistrationModal, setShowOtherRegistrationModal] =
    useState(false);
  const [showCustomerAppRegModal, setShowCustomerAppRegModal] = useState(false);
  const [showAppBroadcastManagerModal, setShowAppBroadcastManagerModal] = useState(false);
  const [showAppConfigMasterModal,     setShowAppConfigMasterModal]     = useState(false);
  const [showInvoiceDesignerModal,     setShowInvoiceDesignerModal]     = useState(false);
  const [schemeRegInitialName, setSchemeRegInitialName] = useState("");
  const [schemeRegInitialScheme, setSchemeRegInitialScheme] = useState(null);

  const [ledgerJustClosed, setLedgerJustClosed] = useState(false);

  const previousFocusRef = useRef(null);

  const openLedgerRegModal = (e) => {
    previousFocusRef.current = e?.target || document.activeElement;
    setZIndices((prev) => ({ ...prev, ledgerReg: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowLedgerRegModal(true);
  };

  const openOtherRegistrationModal = (e) => {
    setZIndices((prev) => ({ ...prev, otherRegistration: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowOtherRegistrationModal(true);
  };

  const openCustomerAppRegModal = () => {
    setZIndices((prev) => ({ ...prev, customerAppReg: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowCustomerAppRegModal(true);
  };

  const openAppBroadcastManagerModal = () => {
    setZIndices((prev) => ({ ...prev, appBroadcastManager: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowAppBroadcastManagerModal(true);
  };

  const openAppConfigMasterModal = () => {
    setZIndices((prev) => ({ ...prev, appConfigMaster: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowAppConfigMasterModal(true);
  };

  const [showPrintModelAssignerModal, setShowPrintModelAssignerModal] = useState(false);

  const openInvoiceDesignerModal = () => {
    setZIndices((prev) => ({ ...prev, invoiceDesigner: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowInvoiceDesignerModal(true);
  };

  const openPrintModelAssignerModal = () => {
    setZIndices((prev) => ({ ...prev, printModelAssigner: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowPrintModelAssignerModal(true);
  };

  // 2.GROUP REGISTRATION

  const [showGroupRegModal, setShowGroupRegModal] = useState(false);

  const openGroupRegModal = (e) => {
    setZIndices((prev) => ({ ...prev, groupReg: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowGroupRegModal(true);
  };

  const [showGroupListModal, setShowGroupListModal] = useState(false);

  const openGroupListModal = () => {
    setZIndices((prev) => ({ ...prev, groupList: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowGroupListModal(true);
  };

  const [showGroupListReportModal, setShowGroupListReportModal] =
    useState(false);

  const openGroupListReportModal = (payload) => {
    setGroupListPayload(payload);
    setZIndices((prev) => ({ ...prev, groupListReport: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowGroupListReportModal(true);
  };

  // -------------------------------------------------------------------------

  const openStaffRegModal = () => {
    setZIndices((prev) => ({ ...prev, staffReg: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowStaffRegModal(true);
  };

  const openReceiptModal = (frmId, fname, voucherType) => {
    setReceiptFormInfo({ id: frmId, name: fname, voucherType });
    setZIndices((prev) => ({ ...prev, receipt: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowReceiptModal(true);
  };

  const openRedeemModal = (frmId, fname, voucherType) => {
    setRedeemFormInfo({
      id: frmId || "",
      name: fname || "",
      voucherType: voucherType || "SCHEME REDEEM",
    });
    setZIndices((prev) => ({ ...prev, redeem: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowRedeemModal(true);
  };

  const openReportModal = () => {
    setZIndices((prev) => ({ ...prev, report: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowReportModal(true);
  };

  const openRateClassModal = () => {
    setZIndices((prev) => ({ ...prev, rateClass: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowRateClassModal(true);
  };

  const openStockGroupModal = () => {
    setZIndices((prev) => ({ ...prev, stockGroup: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowStockGroupModal(true);
  };

  const openModelRegModal = () => {
    setZIndices((prev) => ({ ...prev, modelReg: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowModelRegModal(true);
  };

  const openRateSettingsModal = () => {
    setZIndices((prev) => ({ ...prev, rateSettings: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowRateSettingsModal(true);
  };

  const openReceiptListModal = () => {
    setZIndices((prev) => ({ ...prev, receiptList: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowReceiptListModal(true);
  };

  const openFormRegModal = () => {
    setZIndices((prev) => ({ ...prev, formReg: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowFormRegModal(true);
  };

  const opendayBookModal = () => {
    setZIndices((prev) => ({ ...prev, dayBook: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setDayBookModal(true);
  };

  const openjvModal = (frmId = "", fname = "", voucherType = "JOURNAL") => {
    setJvFormInfo({ id: frmId, name: fname, voucherType });
    setZIndices((prev) => ({ ...prev, jv: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setJvModal(true);
  };

  const opencvModal = (frmId = "", fname = "", voucherType = "CONTRA") => {
    setCvFormInfo({ id: frmId, name: fname, voucherType });
    setZIndices((prev) => ({ ...prev, cv: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setCvModal(true);
  };

  const openledgerdiaModal = () => {
    setZIndices((prev) => ({ ...prev, ledgerDia: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setledgerdiaModal(true);
  };

  const openPurchaseListModal = () => {
    setZIndices((prev) => ({ ...prev, purchaseList: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowPurchaseListModal(true);
  };

  const openSchemeReport = () => {
    openFindDialog();
    reportAgent();
  };

  const openPurchaseListReportModal = (payload) => {
    setPurchaseListPayload(payload);
    setZIndices((prev) => ({ ...prev, purchaseListReport: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowPurchaseListReportModal(true);
  };

  const openQuicksearchModal = () => {
    setZIndices((prev) => ({ ...prev, qSearch: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setQsearchModal(true);
  };

  const [ProductRegJustClosed, setProductRegJustClosed] = useState(false);

  const openProductRegModal = () => {
    setZIndices((prev) => ({ ...prev, productReg: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowProductRegModal(true);
  };

  const [softwaresettings, setSoftwaresettings] = useState(false);

  const openSoftwareSettings = () => {
    setZIndices((prev) => ({ ...prev, softwaresettings: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setSoftwaresettings(true);
  };

  const [LedreportData, setLedreportData] = useState(null);

  const openledgerreportModal = (leddata) => {
    setZIndices((prev) => ({ ...prev, ledgerReport: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setLedreportData(leddata);
    setledgerReportModal(true);
  };

  const [dayBookData, setDayBookData] = useState(null);

  const opendayBookReportModal = (dayBookData) => {
    setZIndices((prev) => ({ ...prev, dayBookReport: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setDayBookReportModal(true);
    setDayBookData(dayBookData);
  };

  const [receiptListReportData, setReceiptListReportData] = useState(null);

  const openReceiptListReportModal = (reportData) => {
    setZIndices((prev) => ({ ...prev, receiptListReport: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowReceiptListReportModal(true);
    setReceiptListReportData(reportData);
  };

  const openReportPage = () => {
    navigate("/report");
  };

  const [showFindDialog, setShowFindDialog] = useState(false);
  const [findEntryNo, setFindEntryNo] = useState("");

  const openFindDialog = () => {
    setZIndices((prev) => ({ ...prev, recOptions: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowFindDialog(true);
    fetchRegCname();
    fetchAgname();
    fetchAccno();
  };

  const closeFindDialog = (e) => {
    handleClear(e);
    setShowFindDialog(false);
    setFindEntryNo("");
  };

  const isMobile = window.innerWidth <= 768;
  const customerRef = useRef(null);
  const agentRef = useRef(null);
  const pNoRef = useRef(null);
  const accRef = useRef(null);

  const [RegcnameData, setRegCnameData] = useState([]);

  useEffect(() => {
    const fetchRegCname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_schemeregisteredcustomers/${dbCode}`,
        );
        const cName = response.data;
        const transformedData = cName.map((item) => [
          item.accname,
          item.LedName,
        ]);
        setRegCnameData(transformedData);
      } catch (error) {
        console.error("Error fetching regcustomers Values:", error.message);
      }
    };
    fetchRegCname();
  }, [apiBaseUrl]);

  const fetchRegCname = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_schemeregisteredcustomers/${dbCode}`,
      );
      const cName = response.data;
      const transformedData = cName.map((item) => [item.accname, item.LedName]);
      setRegCnameData(transformedData);
    } catch (error) {
      console.error("Error fetching regcustomers Values:", error.message);
    }
  };

  const [agentName, setagentName] = useState([]);
  const [agentobj, setAgentObj] = useState([]);

  const fetchAgname = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/schsalesmanNames/${dbCode}`,
      );
      const AgName = response.data;
      const transformedData = AgName.map((item) => [item.Auto, item.Name]);
      setagentName(transformedData);
    } catch (error) {
      console.error("Error fetching agent Values:", error.message);
    }
  };

  useEffect(() => {
    const fetchAgname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/schsalesmanNames/${dbCode}`,
        );
        const AgName = response.data;
        const transformedData = AgName.map((item) => [item.Auto, item.Name]);
        setagentName(transformedData);
      } catch (error) {
        console.error("Error fetching agent Values:", error.message);
      }
    };
    fetchAgname();
  }, [apiBaseUrl]);

  const [accNo, setaccNo] = useState([]);

  const fetchAccno = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_Accno/${dbCode}`,
      );
      const Accno = response.data;
      const transformedData = Accno.map((item) => [item.auto, item.accno]);
      setaccNo(transformedData);
    } catch (error) {
      console.error("Error fetching accno Values:", error.message);
    }
  };

  useEffect(() => {
    const fetchAccno = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_Accno/${dbCode}`,
        );
        const Accno = response.data;
        const transformedData = Accno.map((item) => [item.auto, item.accno]);
        setaccNo(transformedData);
      } catch (error) {
        console.error("Error fetching accno Values:", error.message);
      }
    };
    fetchAccno();
  }, [apiBaseUrl]);

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handlePopstate);
    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);

  const handlePopstate = () => {
    window.history.pushState(null, null, window.location.pathname);
  };

  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const schemeRegistrationRef = useRef(null);

  const handleClearInSchemeReg = () => {
    if (schemeRegistrationRef.current) {
      schemeRegistrationRef.current.handleClear();
    }
  };

  const handleExit = () => {
    if (window.confirm("Do you want to backUp...?")) {
      downloadBackup().then(() => {
        const storedDbCode = localStorage.getItem("dbCode");
        if (!storedDbCode) {
          navigate("/");
        } else {
          navigate("/login");
        }
      });
    } else {
      const storedDbCode = localStorage.getItem("dbCode");
      if (!storedDbCode) {
        navigate("/");
      } else {
        navigate("/login");
      }
    }
  };

  const reportAgent = () => {
    if (userType === "CUSTOMERS") {
      setReportData({
        ...ReportData,
        // customer: RegcnameData.find((item) => item[0] === parseInt(userCode)),
        accno: accNo.find((item) => item[1] === userAccno),
      });
    } else {
      setReportData({
        ...ReportData,
        agent: agentName.find((item) => item[0] === parseInt(agentCode)),
      });
    }
  };

  const [allForms, setAllForms] = useState([]);

  const allschemeforms = useMemo(() => {
    return allForms
      .filter(
        (item) =>
          item.fmrTypeOfVoucher === "SCHEME RECEIPT" ||
          item.fmrTypeOfVoucher === "SCHEME REDEEM",
      )
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
      }));
  }, [allForms]);

  const fetchAllformDatas = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/common/selectAllformDatas/${dbCode}`,
      );
      setAllForms(response.data || []);
    } catch (error) {
      console.error("Error fetching all form datas:", error.message);
    }
  };

  useEffect(() => {
    fetchAllformDatas();
  }, [apiBaseUrl]);

  useEffect(() => {
    const socket = io(apiBaseUrl);
    socket.on("formUpdated", () => {
      fetchAllformDatas();
    });
  }, [apiBaseUrl]);

  const [companyName, setCompanyName] = useState("SherGold ERP");
  useEffect(() => {
    fetchcompanydetails();
  }, [apiBaseUrl]);

  const fetchcompanydetails = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/findCompanyDetails/${dbCode}`,
      );
      const foundData = response.data[0];
      setCompanyName(foundData.name || "SherGold ERP");
      return foundData.Code;
    } catch (error) {
      console.error("Error fetching company datas:", error.message);
    }
  };

  // const downloadBackup = async () => {
  //   const code = await fetchcompanydetails();
  //   const response = await fetch(
  //     `${apiBaseUrl}/main/export-all-tables-xml-zip/${dbCode}`,
  //     {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/zip",
  //       },
  //     }
  //   );
  //   if (response.ok) {
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(new Blob([blob]));
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", `${dbCode}_backup.zip`);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.parentNode.removeChild(link);
  //   } else {
  //     console.error("Failed to download the backup");
  //     alert("Failed to download the backup");
  //   }
  // };
  const downloadBackup = async () => {
    setIsDownloading(true);
    setBackupStatus("preparing");
    setBackupBytesLoaded(0);
    setBackupError("");

    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/export-all-tables-xml-zip/${dbCode}`,
        {
          responseType: "blob",
          onDownloadProgress: (progressEvent) => {
            const loaded = progressEvent.loaded || 0;
            setBackupBytesLoaded(loaded);
            if (loaded > 0) {
              setBackupStatus("downloading");
            }
          },
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${dbCode}_backup.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setBackupStatus("success");
      // Give the user time to see the success state before closing
      setTimeout(() => {
        setIsDownloading(false);
        setBackupStatus("idle");
      }, 2500);
    } catch (error) {
      console.error("Error downloading backup:", error.message);
      setBackupStatus("error");
      setBackupError(error.message || "Failed to download backup archive.");
    }
  };
  const [agreportData, setAgreportData] = useState(null);

  const [eventData, seteventData] = useState(null);

  const [showRecOptions, setShowRecOptions] = useState(false);
  const [showRedeemOptions, setShowRedeemOptions] = useState(false);

  const openRecOptions = () => {
    setZIndices((prev) => ({ ...prev, recOptions: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowRecOptions(true);
  };

  const closeRecOptions = () => {
    setShowRecOptions(false);
  };

  const openRedeemOptions = () => {
    setZIndices((prev) => ({ ...prev, redeemOptions: modalCounter }));
    setModalCounter((prev) => prev + 100);
    setShowRedeemOptions(true);
  };

  const closeRedeemOptions = () => {
    setShowRedeemOptions(false);
  };

  const [formsByagent, setformsByagent] = useState([]);
  const [redeemFormsByagent, setRedeemFormsByagent] = useState([]);

  useEffect(() => {
    const fetchFormsByAgent = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/common/selectfrmDatasByagent/${parseInt(
            agentCode,
          )}/${dbCode}`,
        );
        const formDatas = response.data || [];
        const RecData = formDatas
          .filter(
            (item) =>
              item.fmrTypeOfVoucher === "SCHEME RECEIPT" ||
              item.fmrTypeOfVoucher === "Scheme Receipt Order",
          )
          .map((item) => ({
            id: item.fmrEntryNo,
            label: item.fmrAbbreviation,
            voucherType: item.fmrTypeOfVoucher,
          }));
        setformsByagent(RecData);

        const RedeemData = formDatas
          .filter((item) => item.fmrTypeOfVoucher === "SCHEME REDEEM")
          .map((item) => ({
            id: item.fmrEntryNo,
            label: item.fmrAbbreviation,
            voucherType: item.fmrTypeOfVoucher,
          }));
        setRedeemFormsByagent(RedeemData);
      } catch (error) {
        console.error("Error fetching form Values:", error.message);
      }
    };
    if (agentCode) {
      fetchFormsByAgent();
    }
  }, [apiBaseUrl, userType, agentCode]);

  const [selectedForms, setSelectedForms] = useState([]);

  const toggleFormSelection = (frmId) => {
    setSelectedForms((prevSelected) =>
      prevSelected.includes(frmId)
        ? prevSelected.filter((id) => id !== frmId)
        : [...prevSelected, frmId],
    );
  };

  const selectAll = () => {
    const allFormIds = allschemeforms.map((form) => form.id);
    setSelectedForms(allFormIds);
  };

  const unSelectAll = () => {
    setSelectedForms([]);
  };

  useEffect(() => {
    if (userType === "CUSTOMERS") {
      selectAll();
      setReportData((prev) => ({
        ...prev,
        fromDate: "2010-01-01",
      }));
    }
  }, [userType, allschemeforms]);

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-white">
      <SettingsListener />

      <div className="h-[46px] w-full relative z-100000000 shrink-0">
        <MenuBar
          userType={userType}
          allForms={allForms}
          openGoldReceipt={openGoldReceipt}
          agentCode={agentCode}
          dbCode={dbCode}
          openReceiptModal={openReceiptModal}
          openPEntry={openPEntry}
          openCashRec={opencashRec}
          openCashPay={opencashPay}
          openFormRegModal={openFormRegModal}
          openProductRegModal={openProductRegModal}
          openDayBookModal={opendayBookModal}
          openJvModal={openjvModal}
          openCvModal={opencvModal}
          openLedgerDiaModal={openledgerdiaModal}
          openAgReportDiaModal={openagReportdiaModal}
          openQuickSearchModal={openQuicksearchModal}
          downloadBackup={downloadBackup}
          openSmsSettings={openSmsSettings}
          openWhatsAppSettings={openwhatsAppSettings}
          openLedgerListModal={openLedgerListModal}
          openOverDueListModal={openoverDueListModal}
          openEventDetailsModal={openEventModal}
          openRateSettingsModal={openRateSettingsModal}
          openRateClassModal={openRateClassModal}
          openStockGroupModal={openStockGroupModal}
          openModelRegModal={openModelRegModal}
          openStaffRegModal={openStaffRegModal}
          openCreateUserModal={openCreateUserModal}
          openReceiptListModal={openReceiptListModal}
          openRegistrationModal={openRegistrationModal}
          openSchManagementModal={openSchmanagementModal}
          openLedgerRegModal={openLedgerRegModal}
          openOtherRegModal={openOtherRegistrationModal}
          openCustomerAppRegModal={openCustomerAppRegModal}
          openRedeemModal={openRedeemModal}
          openSoftwareSettings={openSoftwareSettings}
          openFinancialYear={openFy}
          openGroupreg={openGroupRegModal}
          openGroupListModal={openGroupListModal}
          openPurchaseList={openPurchaseListModal}
          openSchemeReport={openSchemeReport}
          openAppBroadcastManager={openAppBroadcastManagerModal}
          openAppConfigMaster={openAppConfigMasterModal}
          openPaymentGatewaySettings={openPaymentGatewaySettings}
          openInvoiceDesigner={openInvoiceDesignerModal}
          openPrintModelAssigner={openPrintModelAssignerModal}
        />
      </div>

      <div className="flex-1 flex overflow-hidden relative">
        <Sidebar
          isOpen={showSidebar}
          toggleSidebar={toggleSidebar}
          onMenuItemClick={(itemName) => {
            if (itemName === "Quick Search") {
              if (userType === "ADMIN") {
                openQuicksearchModal();
              } else {
                alert("Only administrators can access Quick Search");
              }
            } else if (itemName === "Product") {
              if (userType === "ADMIN") {
                openProductRegModal();
              } else {
                alert("Only administrators can access Product Registration");
              }
            } else if (itemName === "Ledger") {
              if (userType === "ADMIN" || permissions["ledgerReg"]?.visible) {
                openLedgerRegModal();
              } else {
                alert(
                  "You do not have permission to access Ledger Registration",
                );
              }
            } else if (itemName === "Backup") {
              if (userType === "ADMIN") {
                downloadBackup();
              } else {
                alert("Only administrators can perform a backup");
              }
            } else if (itemName === "Exit") {
              handleExit();
            }
          }}
        />

        <main className="flex-1 overflow-hidden main-area-bg relative flex  px-1 lg:p-8">
          {/* 3-Column Layout */}
          <div className="flex w-full h-full">
            {/* ── LEFT PANEL: SherGold Branding ── */}
            <div className="hidden lg:flex flex-col justify-between py-8 px-6 w-[260px] shrink-0">
              <div>
                <div className="flex items-center text-white text-[28px] 2xl:text-[32px] font-semibold tracking-tight leading-none">
                  SherGold
                  <span className="ml-2.5 erp-gold-sloped-shape text-[14px] 2xl:text-[17px]">
                    <span className="erp-gold-sloped-inner">
                      <span className="erp-gold-sloped-text">ERP</span>
                    </span>
                  </span>
                </div>
                <p className="text-blue-100/90 text-[13px] 2xl:text-[14px] leading-snug italic font-semibold">
                  A Complete Accounting & Inventory <br /> Package
                </p>
              </div>
              <div className="flex items-center gap-4 2xl:gap-5">
                <img
                  src={ss}
                  alt="SherSoft"
                  className="h-20 2xl:h-32 w-auto object-contain shrink-0"
                />
                <div className="text-[13.5px] 2xl:text-[14.5px] leading-snug">
                  <div className="font-extrabold text-white text-[17px] 2xl:text-[19px] mb-1">
                    SherSoft
                  </div>
                  <div className="text-white/85 font-medium">
                    Software Company
                  </div>
                  <div className="text-white/85 font-medium">
                    www.shersoftware.com
                  </div>
                  <div className="text-white/85 font-medium">
                    PH: 9847997755
                  </div>
                  <div className="text-white/85 font-medium">
                    shersoftware@gmail.com
                  </div>
                </div>
              </div>
            </div>

            {/* ── CENTER: Company Name + Grid ── */}
            <div className="flex-1 flex flex-col items-center justify-center min-w-0">
              <div className="text-white text-[20px] lg:text-[24px] font-semibold tracking-wide text-center font-inter mb-2 lg:mb-5 uppercase">
                {companyName}
              </div>
              <div className="h-auto w-auto max-w-full flex items-center justify-center overflow-visible py-1 lg:py-4 px-2">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-2 lg:gap-5 xl:gap-6 2xl:gap-8">
                  {permissions["schemeReg"]?.visible && (
                    <button
                      className="group home-action-btn w-20 h-14 sm:w-24 sm:h-16 md:w-36 md:h-24 lg:w-44 lg:h-28 xl:w-48 xl:h-28 2xl:w-56 2xl:h-32 max-w-full px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-1 active:scale-95"
                      onClick={() =>
                        openRegistrationModal(
                          permissions["schemeReg"]?.actions || {},
                        )
                      }
                    >
                      <div className="home-action-icon w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 2xl:w-14 2xl:h-14 rounded-full border border-white/40 flex items-center justify-center mb-1 lg:mb-2 2xl:mb-3 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                        <FiFileText className="text-base sm:text-lg lg:text-xl 2xl:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
                      </div>
                      <span className="font-medium text-[11px] sm:text-xs 2xl:text-sm tracking-wide text-white/95 group-hover:text-white drop-shadow-sm">
                        Registration
                      </span>
                    </button>
                  )}

                  {permissions["schemecashReceipt"]?.visible && (
                    <button
                      className="group home-action-btn w-20 h-14 sm:w-24 sm:h-16 md:w-36 md:h-24 lg:w-44 lg:h-28 xl:w-48 xl:h-28 2xl:w-56 2xl:h-32 max-w-full px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-1 active:scale-95"
                      onClick={openRecOptions}
                    >
                      <div className="home-action-icon w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 2xl:w-14 2xl:h-14 rounded-full border border-white/40 flex items-center justify-center mb-1 lg:mb-2 2xl:mb-3 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                        <div className="relative flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                          <FiFile className="text-base sm:text-lg lg:text-xl 2xl:text-2xl text-white drop-shadow-sm" />
                          <span className="absolute text-[8px] lg:text-[10px] 2xl:text-[11px] font-bold text-white mt-[2px]">
                            $
                          </span>
                        </div>
                      </div>
                      <span className="font-medium text-[11px] sm:text-xs 2xl:text-sm tracking-wide text-white/95 group-hover:text-white drop-shadow-sm">
                        Cash Receipt
                      </span>
                    </button>
                  )}

                  {permissions["ledgerReg"]?.visible && (
                    <button
                      className="group home-action-btn w-20 h-14 sm:w-24 sm:h-16 md:w-36 md:h-24 lg:w-44 lg:h-28 xl:w-48 xl:h-28 2xl:w-56 2xl:h-32 max-w-full px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-1 active:scale-95"
                      onClick={openLedgerRegModal}
                    >
                      <div className="home-action-icon w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 2xl:w-14 2xl:h-14 rounded-full border border-white/40 flex items-center justify-center mb-1 lg:mb-2 2xl:mb-3 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                        <FiBookOpen className="text-base sm:text-lg lg:text-xl 2xl:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
                      </div>
                      <span className="font-medium text-[11px] sm:text-xs 2xl:text-sm tracking-wide text-white/95 group-hover:text-white drop-shadow-sm">
                        Ledger Reg
                      </span>
                    </button>
                  )}

                  {permissions["employeeReg"]?.visible && (
                    <button
                      className="group home-action-btn w-20 h-14 sm:w-24 sm:h-16 md:w-36 md:h-24 lg:w-44 lg:h-28 xl:w-48 xl:h-28 2xl:w-56 2xl:h-32 max-w-full px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-1 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:transform-none disabled:hover:shadow-none"
                      onClick={openStaffRegModal}
                      disabled={userType !== "ADMIN"}
                    >
                      <div className="home-action-icon w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 2xl:w-14 2xl:h-14 rounded-full border border-white/40 flex items-center justify-center mb-1 lg:mb-2 2xl:mb-3 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                        <FiUsers className="text-base sm:text-lg lg:text-xl 2xl:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
                      </div>
                      <span className="font-medium text-[11px] sm:text-xs 2xl:text-sm tracking-wide text-white/95 group-hover:text-white drop-shadow-sm">
                        Staff Reg
                      </span>
                    </button>
                  )}

                  {permissions["schemeRedeem"]?.visible && (
                    <button
                      className="group home-action-btn w-20 h-14 sm:w-24 sm:h-16 md:w-36 md:h-24 lg:w-44 lg:h-28 xl:w-48 xl:h-28 2xl:w-56 2xl:h-32 max-w-full px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-1 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:transform-none disabled:hover:shadow-none"
                      onClick={openRedeemOptions}
                      disabled={userType !== "ADMIN"}
                    >
                      <div className="home-action-icon w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 2xl:w-14 2xl:h-14 rounded-full border border-white/40 flex items-center justify-center mb-1 lg:mb-2 2xl:mb-3 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                        <FiGift className="text-base sm:text-lg lg:text-xl 2xl:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
                      </div>
                      <span className="font-medium text-[11px] sm:text-xs 2xl:text-sm tracking-wide text-white/95 group-hover:text-white drop-shadow-sm">
                        Redeem
                      </span>
                    </button>
                  )}

                  {permissions["schemeReport"]?.visible && (
                    <button
                      className="group home-action-btn w-20 h-14 sm:w-24 sm:h-16 md:w-36 md:h-24 lg:w-44 lg:h-28 xl:w-48 xl:h-28 2xl:w-56 2xl:h-32 max-w-full px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-1 active:scale-95"
                      onClick={(e) => {
                        openFindDialog(e);
                        reportAgent(e);
                      }}
                    >
                      <div className="home-action-icon w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 2xl:w-14 2xl:h-14 rounded-full border border-white/40 flex items-center justify-center mb-1 lg:mb-2 2xl:mb-3 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                        <FiBarChart2 className="text-base sm:text-lg lg:text-xl 2xl:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
                      </div>
                      <span className="font-medium text-[11px] sm:text-xs 2xl:text-sm tracking-wide text-white/95 group-hover:text-white drop-shadow-sm">
                        Scheme Report
                      </span>
                    </button>
                  )}

                  {permissions["rateclassReg"]?.visible && (
                    <button
                      className="group home-action-btn w-20 h-14 sm:w-24 sm:h-16 md:w-36 md:h-24 lg:w-44 lg:h-28 xl:w-48 xl:h-28 2xl:w-56 2xl:h-32 max-w-full px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-1 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:transform-none disabled:hover:shadow-none"
                      onClick={openRateClassModal}
                      disabled={userType !== "ADMIN"}
                    >
                      <div className="home-action-icon w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 2xl:w-14 2xl:h-14 rounded-full border border-white/40 flex items-center justify-center mb-1 lg:mb-2 2xl:mb-3 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                        <FaRupeeSign className="text-base sm:text-lg lg:text-xl 2xl:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
                      </div>
                      <span className="font-medium text-[11px] sm:text-xs 2xl:text-sm tracking-wide text-white/95 group-hover:text-white drop-shadow-sm">
                        Rate Class
                      </span>
                    </button>
                  )}

                  {permissions["rateSettings"]?.visible && (
                    <button
                      className="group home-action-btn w-20 h-14 sm:w-24 sm:h-16 md:w-36 md:h-24 lg:w-44 lg:h-28 xl:w-48 xl:h-28 2xl:w-56 2xl:h-32 max-w-full px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-1 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:transform-none disabled:hover:shadow-none"
                      onClick={openRateSettingsModal}
                      disabled={userType !== "ADMIN"}
                    >
                      <div className="home-action-icon w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 2xl:w-14 2xl:h-14 rounded-full border border-white/40 flex items-center justify-center mb-1 lg:mb-2 2xl:mb-3 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                        <FiSettings className="text-base sm:text-lg lg:text-xl 2xl:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
                      </div>
                      <span className="font-medium text-[11px] sm:text-xs 2xl:text-sm tracking-wide text-white/95 group-hover:text-white drop-shadow-sm">
                        Rate Settings
                      </span>
                    </button>
                  )}

                  <button
                    className="group home-action-btn w-20 h-14 sm:w-24 sm:h-16 md:w-36 md:h-24 lg:w-44 lg:h-28 xl:w-48 xl:h-28 2xl:w-56 2xl:h-32 max-w-full px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-1 active:scale-95"
                    onClick={handleExit}
                  >
                    <div className="home-action-icon w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 2xl:w-14 2xl:h-14 rounded-full border border-white/40 flex items-center justify-center mb-1 lg:mb-2 2xl:mb-3 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                      <FiPower className="text-base sm:text-lg lg:text-xl 2xl:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
                    </div>
                    <span className="font-medium text-[11px] sm:text-xs 2xl:text-sm tracking-wide text-white/95 group-hover:text-white drop-shadow-sm">
                      Exit
                    </span>
                  </button>
                </div>
              </div>
            </div>

            {/* ── RIGHT PANEL: Live Rates Card & Notifications ── */}
            <div className="hidden lg:flex flex-col justify-between py-2 xl:py-4 2xl:py-6 px-3 w-[260px] xl:w-[275px] 2xl:w-[290px] shrink-0 h-full overflow-hidden">
              <div className="z-10 w-full shrink-0">
                <LiveRateCard onOpenRateSettings={openRateSettingsModal} />
              </div>
              {showNotification && (
                <div
                  className={`bg-white/30 backdrop-blur-lg border border-white/35 rounded-xl p-4 relative shadow-2xl shrink-0 mt-auto transform transition-all duration-[2200ms] ${
                    animateNotification
                      ? "translate-y-0 opacity-100"
                      : "translate-y-[200%] opacity-0"
                  }`}
                  style={{
                    transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
                  }}
                >
                  <div className="flex items-start justify-between gap-1 mb-2">
                    <p className="text-black font-inter text-[12px] 2xl:text-[13px] leading-snug pr-3 font-semibold">
                      Please take backup to external media regularly. SherSoft has no responsibility for data loss.
                    </p>
                    <button
                      className="w-5 h-5 flex items-center justify-center bg-red-100 hover:bg-red-500 hover:text-white text-red-600 rounded-full font-extrabold text-[10px] shrink-0 border-0 cursor-pointer select-none transition-all duration-200 mt-0.5"
                      onClick={() => setShowNotification(false)}
                    >
                      ✕
                    </button>
                  </div>
                  <div className="mt-3 pt-3 border-t border-black/10 text-[11px] 2xl:text-[12px] font-inter text-[#000080]">
                    <span className="font-semibold block mb-1">For Support Contact Us:</span>
                    <div className="leading-snug font-medium flex flex-col gap-0.5 tabular-nums text-[11.5px] 2xl:text-[12.5px]">
                      <span>7560889991, 7560889992</span>
                      <span>7560889970, 7560880900</span>
                      <span>7560888930, 7560888669</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* Centered Modals Wrapper */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-[100] [&>*]:pointer-events-auto">
            {showRegistrationModal && (
              <SchemeRegistration
                initialAccountName={schemeRegInitialName}
                initialScheme={schemeRegInitialScheme}
                onClose={() => {
                  setShowRegistrationModal(false);
                  setSchemeRegInitialName("");
                  setSchemeRegInitialScheme(null);
                  setTimeout(() => {
                    document.getElementById("customer-app-scheme-combo")?.focus();
                  }, 100);
                }}
                Open={(e, accountNameInputRef) => {
                  setLedval(e.target.value);
                  setUnder("CUSTOMERS");
                  openLedgerRegModal();
                  sessionStorage.setItem(
                    "accountNameInputRef",
                    accountNameInputRef,
                  );
                }}
                OpenSchemeMgmt={(e, schemeNameInputRef) => {
                  setSchMgName(e.target.value);
                  openSchmanagementModal();
                  sessionStorage.setItem(
                    "schemeNameInputRef",
                    schemeNameInputRef,
                  );
                }}
                zIndex={zIndices["registration"]}
                actionPermissions={permissions["schemeReg"]?.actions || {}} // Pass actions
              />
            )}
            {showschManagmentModal && (
              <SchemeManagement
                onClose={() => setShowschManagmentModal(false)}
                Open={(e, accountNameInputRef) => {
                  setLedval(e.target.value);
                  openLedgerRegModal();
                  sessionStorage.setItem(
                    "accountNameInputRef",
                    accountNameInputRef,
                  );
                }}
                zIndex={zIndices["schManagement"]}
                actionPermissions={permissions["schManagement"]?.actions || {}} // Pass actions
                schemeNameVal={schMgName}
              />
            )}

            {/* ----------------------Account Registration Modals----------------------- */}

            {showLedgerRegModal && (
              <LedgerReg
                onClose={() => {
                  setShowLedgerRegModal(false);
                  setLedval("");
                  setUnder("");
                  setLedgerJustClosed(true);
                  setTimeout(() => setLedgerJustClosed(false), 300);
                  if (previousFocusRef.current) {
                    setTimeout(() => previousFocusRef.current.focus(), 100);
                  }
                }}
                val={ledval || ""}
                underVal={under || ""}
                zIndex={zIndices["ledgerReg"]}
              />
            )}

            {showOtherRegistrationModal && (
              <OtherRegistration
                onClose={() => {
                  setShowOtherRegistrationModal(false);
                }}
                zIndex={zIndices["otherRegistration"]}
              />
            )}

            {showCustomerAppRegModal && (
              <CustomerAppReg
                onClose={() => setShowCustomerAppRegModal(false)}
                zIndex={zIndices["customerAppReg"]}
                onOpenSchemeRegistration={openRegistrationModal}
              />
            )}

            {showGroupRegModal && (
              <GroupRegistration
                onClose={() => {
                  setShowGroupRegModal(false);
                }}
                zIndex={zIndices["groupReg"]}
              />
            )}

            {showGroupListModal && (
              <GroupList
                onClose={() => {
                  setShowGroupListModal(false);
                  handleClear();
                }}
                openReport={openGroupListReportModal}
                zIndex={zIndices["groupList"]}
              />
            )}

            {showGroupListReportModal && (
              <GroupListReport
                payload={groupListPayload}
                onClose={() => {
                  setShowGroupListReportModal(false);
                  handleClear();
                  setGroupListPayload(null);
                }}
                zIndex={zIndices["groupListReport"]}
              />
            )}

            {/* ------------------------------------------------------------ */}

            {showStaffRegModal && (
              <StaffReg
                onClose={() => setShowStaffRegModal(false)}
                Open={(e, cashAccInputRef) => {
                  const val = typeof e === "string" ? e : (e?.target?.value || "");
                  setLedval(val);
                  setUnder("CASH IN HAND");
                  openLedgerRegModal(e);
                  sessionStorage.setItem("staffRegCashAccountFocus", "true");
                  if (val) {
                    sessionStorage.setItem("staffRegTypedCashAccount", val);
                  }
                }}
                ledgerJustClosed={ledgerJustClosed}
                zIndex={zIndices["staffReg"]}
              />
            )}
            {showReceiptModal && (
              <SchemeCashReceipt
                onClose={() => {
                  setShowReceiptModal(false);
                  setReceiptFormInfo({ id: "", name: "", voucherType: "" });
                }}
                agent={agentCode}
                formId={receiptFormInfo.id}
                formName={receiptFormInfo.name}
                voucherType={receiptFormInfo.voucherType}
                zIndex={zIndices["receipt"]}
              />
            )}
            {showRedeemModal && (
              <SchemeRedeem
                onClose={() => {
                  setShowRedeemModal(false);
                  setRedeemFormInfo({ id: "", name: "", voucherType: "" });
                }}
                formId={redeemFormInfo.id}
                formName={redeemFormInfo.name}
                voucherType={redeemFormInfo.voucherType}
                zIndex={zIndices["redeem"]}
              />
            )}
            {showReportModal && schemeReportPayload && (
              <SchemeReport
                onClose={() => {
                  setShowReportModal(false);
                  setSchemeReportPayload(null);
                }}
                reportData={schemeReportPayload.reportData}
                forms={schemeReportPayload.forms}
                zIndex={zIndices["report"]}
              />
            )}
            {showRateClassModal && (
              <RateClassReg
                onClose={() => {
                  setShowRateClassModal(false);
                  handleClear();
                }}
                zIndex={zIndices["rateClass"]}
              />
            )}
            {showStockGroupModal && (
              <StockGroupReg
                onClose={() => {
                  setShowStockGroupModal(false);
                  handleClear();
                }}
                zIndex={zIndices["stockGroup"]}
              />
            )}
            {showModelRegModal && (
              <ModelReg
                onClose={() => {
                  setShowModelRegModal(false);
                  handleClear();
                }}
                zIndex={zIndices["modelReg"]}
              />
            )}
            {showRateSettingsModal && (
              <RateSettings
                onClose={() => {
                  setShowRateSettingsModal(false);
                  handleClear();
                }}
                zIndex={zIndices["rateSettings"]}
              />
            )}
            {showReceiptListModal && (
              <ReceiptList
                onClose={() => {
                  setShowReceiptListModal(false);
                  handleClear();
                }}
                openReceiptListReport={openReceiptListReportModal}
                zIndex={zIndices["receiptList"]}
              />
            )}
            {showReceiptListReportModal && (
              <ReceiptListReport
                onClose={() => {
                  setShowReceiptListReportModal(false);
                  handleClear();
                }}
                reportData={receiptListReportData}
                zIndex={zIndices["receiptListReport"]}
              />
            )}
            {showFormRegModal && (
              <FormRegistration
                onClose={() => {
                  setShowFormRegModal(false);
                  handleClear();
                }}
                zIndex={zIndices["formReg"]}
              />
            )}
            {showdayBookModal && (
              <DayBook
                onClose={() => {
                  setDayBookModal(false);
                  handleClear();
                }}
                openReport={opendayBookReportModal}
                zIndex={zIndices["dayBook"]}
              />
            )}
            {showdayBookReportModal && (
              <DayBookReport
                onClose={() => {
                  setDayBookReportModal(false);
                  handleClear();
                }}
                dayBookRepData={dayBookData}
                zIndex={zIndices["dayBookReport"]}
              />
            )}
            {showjvModal && (
              <JournalEntry
                onClose={() => {
                  setJvModal(false);
                  setJvFormInfo({ id: "", name: "", voucherType: "JOURNAL" });
                  handleClear();
                }}
                Open={(e, rowIndex, columnIndex) => {
                  setLedval(e.target.value);
                  openLedgerRegModal(e);
                  sessionStorage.setItem("journalEntryRowIndex", rowIndex);
                  sessionStorage.setItem(
                    "journalEntryColumnIndex",
                    columnIndex,
                  );
                }}
                ledgerJustClosed={ledgerJustClosed}
                formId={jvFormInfo.id}
                formName={jvFormInfo.name}
                voucherType={jvFormInfo.voucherType}
                zIndex={zIndices["jv"]}
              />
            )}
            {showcvModal && (
              <ContraEntry
                onClose={() => {
                  setCvModal(false);
                  setCvFormInfo({ id: "", name: "", voucherType: "CONTRA" });
                  handleClear();
                }}
                Open={(e, rowIndex, columnIndex) => {
                  setLedval(e.target.value);
                  openLedgerRegModal(e);
                  sessionStorage.setItem("contraEntryRowIndex", rowIndex);
                  sessionStorage.setItem("contraEntryColumnIndex", columnIndex);
                }}
                formId={cvFormInfo.id}
                formName={cvFormInfo.name}
                voucherType={cvFormInfo.voucherType}
                zIndex={zIndices["cv"]}
              />
            )}
            {showledgerdiaModal && (
              <LedgerRepModel
                onClose={() => {
                  setledgerdiaModal(false);
                  handleClear();
                }}
                openReport={openledgerreportModal}
                zIndex={zIndices["ledgerDia"]}
              />
            )}
            {showPurchaseListModal && (
              <PurchaseListDialog
                onClose={() => setShowPurchaseListModal(false)}
                openReport={openPurchaseListReportModal}
                zIndex={zIndices["purchaseList"]}
              />
            )}
            {showPurchaseListReportModal && (
              <PurchaseList
                onClose={() => {
                  setShowPurchaseListReportModal(false);
                  setPurchaseListPayload(null);
                  handleClear();
                }}
                payload={purchaseListPayload}
                zIndex={zIndices["purchaseListReport"]}
              />
            )}
            {showledgerReportModal && (
              <LedgerReport
                onClose={() => {
                  setledgerReportModal(false);
                  handleClear();
                }}
                ledgerReportData={LedreportData}
                zIndex={zIndices["ledgerReport"]}
              />
            )}
            {showqSearchModal && (
              <QuickSearch
                onClose={() => {
                  setQsearchModal(false);
                  handleClear();
                }}
                zIndex={zIndices["qSearch"]}
              />
            )}
            {showagReportdiaModal && (
              <AgentReportModel
                onClose={() => {
                  setShowagReportdiaModal(false);
                  handleClear();
                }}
                openReport={openAgreport}
                zIndex={zIndices["agReportDia"]}
              />
            )}
            {showagReportModal && (
              <AgentReport
                onClose={() => {
                  setShowagReportModal(false);
                  handleClear();
                }}
                agentReportData={agreportData}
                zIndex={zIndices["agReport"]}
              />
            )}
            {showeventDetailsModal && (
              <EventDetails
                onClose={() => {
                  setShoweventDetailsModal(false);
                  handleClear();
                }}
                openReport={openEventReport}
                zIndex={zIndices["eventDetails"]}
              />
            )}
            {showeventRepModal && (
              <EventDetailsReport
                onClose={() => {
                  setShoweventRepModal(false);
                  handleClear();
                }}
                eventReportData={eventData}
                zIndex={zIndices["eventRep"]}
              />
            )}
            {showSmssettingsModal && (
              <SmsSettings
                onClose={() => {
                  setShowSmssettingsModal(false);
                }}
                zIndex={zIndices["smsSettings"]}
              />
            )}
            {showwhatsappsettingsModal && (
              <WhatsAppSettings
                onClose={() => {
                  setShowwhatsappsettingsModal(false);
                }}
                zIndex={zIndices["whatsAppSettings"]}
              />
            )}
            {showPaymentGatewaySettingsModal && (
              <PaymentGatewaySettings
                onClose={() => {
                  setShowPaymentGatewaySettingsModal(false);
                }}
                zIndex={zIndices["paymentGatewaySettings"] || 1000}
              />
            )}
            {showcashRecModal && (
              <CashReceipt
                onClose={() => {
                  setShowCashRecModal(false);
                  setCashRecFormInfo({ id: "", name: "", voucherType: "" });
                }}
                Open={(e, rowIndex, columnIndex) => {
                  setLedval(e.target.value);
                  openLedgerRegModal(e);
                  sessionStorage.setItem("cashRecEntryRowIndex", rowIndex);
                  sessionStorage.setItem(
                    "cashRecEntryColumnIndex",
                    columnIndex,
                  );
                }}
                ledgerJustClosed={ledgerJustClosed}
                formId={cashRecFormInfo.id}
                formName={cashRecFormInfo.name}
                voucherType={cashRecFormInfo.voucherType}
                zIndex={zIndices["cashRec"]}
              />
            )}
            {showcashPayModal && (
              <CashPayment
                onClose={() => {
                  setShowCashPayModal(false);
                  setCashPayFormInfo({ id: "", name: "", voucherType: "" });
                }}
                Open={(e, rowIndex, columnIndex) => {
                  setLedval(e.target.value);
                  openLedgerRegModal(e);
                  sessionStorage.setItem("cashPayEntryRowIndex", rowIndex);
                  sessionStorage.setItem(
                    "cashPayEntryColumnIndex",
                    columnIndex,
                  );
                }}
                ledgerJustClosed={ledgerJustClosed}
                formId={cashPayFormInfo.id}
                formName={cashPayFormInfo.name}
                voucherType={cashPayFormInfo.voucherType}
                zIndex={zIndices["cashPay"]}
              />
            )}
            {showLedgerListModal && (
              <LedgerList
                onClose={() => {
                  setShowLedgerListModal(false);
                  setLedgerListInitialParent(null);
                }}
                zIndex={zIndices["ledgerList"]}
                initialParent={ledgerListInitialParent}
              />
            )}
            {showoverDueListModal && (
              <SchemeOverDue
                onClose={() => {
                  setShowOverDueListModal(false);
                }}
                zIndex={zIndices["overDueList"]}
              />
            )}
            {showproductRegModal && (
              <ProductReg
                onClose={() => {
                  setShowProductRegModal(false);
                  setPrdValue("");
                  setProductRegJustClosed(true);
                }}
                val={PrdValue || ""}
                zIndex={zIndices["productReg"]}
              />
            )}
            {showPurchaseEntyModal && (
              <PurchaseEntry
                onClose={() => {
                  setShowPurchaseEntyModal(false);
                  setPurchaseFormInfo({ id: "", name: "", voucherType: "" });
                }}
                Open={(e, accountNameInputRef) => {
                  setLedval(e.target.value);
                  setUnder("SUPPLIERS");
                  openLedgerRegModal(e);
                  sessionStorage.setItem("returnInputRef", accountNameInputRef);
                }}
                OpenPReg={(e, rowIndex, columnIndex, type) => {
                  setPrdValue({ value: e.target.value, type });
                  openProductRegModal(e);
                  sessionStorage.setItem("tableRowIndex", rowIndex);
                  sessionStorage.setItem("tableColumnIndex", columnIndex);
                }}
                pRegJustClosed={ProductRegJustClosed}
                formId={purchaseFormInfo.id}
                formName={purchaseFormInfo.name}
                voucherType={purchaseFormInfo.voucherType}
                zIndex={zIndices["purchaseEntry"]}
              />
            )}
            {showCreateUserModal && (
              <CreateUser
                onClose={() => setShowCreateUserModal(false)}
                zIndex={zIndices["createUser"]}
              />
            )}

            {softwaresettings && (
              <SoftWareSettings
                onClose={() => setSoftwaresettings(false)}
                zIndex={zIndices["softwaresettings"]}
                openSmsSettings={openSmsSettings}
                openwhatsAppSettings={openwhatsAppSettings}
              />
            )}

            {showFyPasswordModal && (
              <PasswordVerification
                onSuccess={handleFyPasswordSuccess}
                onClose={() => setShowFyPasswordModal(false)}
                zIndex={zIndices["fy"]}
              />
            )}

            {showFinancialYearModal && (
              <FinancialYear
                onClose={() => setShowFinancialYearModal(false)}
                zIndex={zIndices["fy"]}
              />
            )}

            <BackupLoader
              isOpen={isDownloading}
              dbCode={dbCode}
              bytesLoaded={backupBytesLoaded}
              status={backupStatus}
              errorMessage={backupError}
              onClose={() => {
                setIsDownloading(false);
                setBackupStatus("idle");
              }}
            />
            {showRecOptions && (
              <div
                className="fixed inset-0 flex items-center justify-center z-50"
                style={{
                  background: "rgba(0,0,20,0.55)",
                  backdropFilter: "blur(4px)",
                }}
                onClick={() => setShowRecOptions(false)}
              >
                <div
                  className="relative w-[320px] max-w-[90vw] rounded-2xl shadow-2xl border border-white/20 overflow-hidden"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(30,60,160,0.82) 0%, rgba(10,30,100,0.92) 100%)",
                    backdropFilter: "blur(18px)",
                    boxShadow:
                      "0 8px 40px 0 rgba(0,0,80,0.45), 0 1.5px 0 0 rgba(255,255,255,0.08) inset",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Header */}
                  <div className="flex items-center justify-between px-5 pt-5 pb-3 border-b border-white/10">
                    <div className="flex items-center gap-2">
                      <div className="w-7 h-7 rounded-full bg-white/10 border border-white/20 flex items-center justify-center">
                        <div className="relative flex items-center justify-center">
                          <FiFile className="text-white text-sm" />
                          <span className="absolute text-[6px] font-bold text-white mt-[1px]">
                            $
                          </span>
                        </div>
                      </div>
                      <span className="text-white font-semibold text-[15px] tracking-wide">
                        Select Receipt Form
                      </span>
                    </div>
                    <button
                      onClick={() => setShowRecOptions(false)}
                      className="w-7 h-7 rounded-full bg-white/10 hover:bg-red-500/70 border border-white/20 flex items-center justify-center text-white/70 hover:text-white transition-all duration-200 text-xs font-bold"
                    >
                      ✕
                    </button>
                  </div>

                  {/* Form buttons */}
                  <div className="p-4 flex flex-col gap-2.5 max-h-[280px] overflow-y-auto">
                    {formsByagent.map((form, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          openReceiptModal(
                            form.id,
                            form.label,
                            form.voucherType,
                          );
                          closeRecOptions();
                        }}
                        className="group w-full flex items-center gap-3 px-4 py-3 rounded-xl border border-white/15 bg-white/8 hover:bg-white/18 hover:border-white/30 text-white text-[13.5px] font-medium tracking-wide transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 text-left"
                        style={{ background: "rgba(255,255,255,0.07)" }}
                      >
                        <div className="w-8 h-8 rounded-full bg-blue-400/20 border border-blue-300/25 flex items-center justify-center shrink-0 group-hover:bg-blue-400/35 transition-all duration-200">
                          <div className="relative flex items-center justify-center">
                            <FiFile className="text-blue-200 text-sm" />
                            <span className="absolute text-[6px] font-bold text-blue-200 mt-[1px]">
                              $
                            </span>
                          </div>
                        </div>
                        <span className="flex-1">{form.label}</span>
                        <span className="text-white/30 group-hover:text-white/60 text-xs transition-colors duration-200">
                          →
                        </span>
                      </button>
                    ))}
                  </div>

                  {/* Footer hint */}
                  <div className="px-5 py-3 border-t border-white/10 text-center">
                    <span className="text-white/35 text-[11px]">
                      Click outside to dismiss
                    </span>
                  </div>
                </div>
              </div>
            )}
            {showRedeemOptions && (
              <div
                className="fixed inset-0 flex items-center justify-center z-50"
                style={{
                  background: "rgba(0,0,20,0.55)",
                  backdropFilter: "blur(4px)",
                }}
                onClick={() => setShowRedeemOptions(false)}
              >
                <div
                  className="relative w-[320px] max-w-[90vw] rounded-2xl shadow-2xl border border-white/20 overflow-hidden"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(30,60,160,0.82) 0%, rgba(10,30,100,0.92) 100%)",
                    backdropFilter: "blur(18px)",
                    boxShadow:
                      "0 8px 40px 0 rgba(0,0,80,0.45), 0 1.5px 0 0 rgba(255,255,255,0.08) inset",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Header */}
                  <div className="flex items-center justify-between px-5 pt-5 pb-3 border-b border-white/10">
                    <div className="flex items-center gap-2">
                      <div className="w-7 h-7 rounded-full bg-white/10 border border-white/20 flex items-center justify-center">
                        <div className="relative flex items-center justify-center">
                          <FiGift className="text-white text-sm" />
                        </div>
                      </div>
                      <span className="text-white font-semibold text-[15px] tracking-wide">
                        Select Redeem Form
                      </span>
                    </div>
                    <button
                      onClick={() => setShowRedeemOptions(false)}
                      className="w-7 h-7 rounded-full bg-white/10 hover:bg-red-500/70 border border-white/20 flex items-center justify-center text-white/70 hover:text-white transition-all duration-200 text-xs font-bold"
                    >
                      ✕
                    </button>
                  </div>

                  {/* Form buttons */}
                  <div className="p-4 flex flex-col gap-2.5 max-h-[280px] overflow-y-auto">
                    {redeemFormsByagent.map((form, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          openRedeemModal(
                            form.id,
                            form.label,
                            form.voucherType,
                          );
                          closeRedeemOptions();
                        }}
                        className="group w-full flex items-center gap-3 px-4 py-3 rounded-xl border border-white/15 bg-white/8 hover:bg-white/18 hover:border-white/30 text-white text-[13.5px] font-medium tracking-wide transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 text-left"
                        style={{ background: "rgba(255,255,255,0.07)" }}
                      >
                        <div className="w-8 h-8 rounded-full bg-blue-400/20 border border-blue-300/25 flex items-center justify-center shrink-0 group-hover:bg-blue-400/35 transition-all duration-200">
                          <div className="relative flex items-center justify-center">
                            <FiGift className="text-blue-200 text-sm" />
                          </div>
                        </div>
                        <span className="flex-1">{form.label}</span>
                        <span className="text-white/30 group-hover:text-white/60 text-xs transition-colors duration-200">
                          →
                        </span>
                      </button>
                    ))}
                  </div>

                  {/* Footer hint */}
                  <div className="px-5 py-3 border-t border-white/10 text-center">
                    <span className="text-white/35 text-[11px]">
                      Click outside to dismiss
                    </span>
                  </div>
                </div>
              </div>
            )}
            {showFindDialog && (
              <SchemeReportDialog
                onClose={() => setShowFindDialog(false)}
                openReport={(payload) => {
                  setShowFindDialog(false);
                  setSchemeReportPayload(payload);
                  setShowReportModal(true);
                }}
                zIndex={zIndices["recOptions"]}
              />
            )}
            {showAppBroadcastManagerModal && (
              <AppBroadcastManager
                onClose={() => setShowAppBroadcastManagerModal(false)}
                zIndex={zIndices["appBroadcastManager"]}
              />
            )}
            {showAppConfigMasterModal && (
              <AppConfigMaster
                onClose={() => setShowAppConfigMasterModal(false)}
                zIndex={zIndices["appConfigMaster"]}
              />
            )}
            {showInvoiceDesignerModal && (
              <InvoiceDesigner
                onClose={() => setShowInvoiceDesignerModal(false)}
                zIndex={zIndices["invoiceDesigner"]}
              />
            )}
            {showPrintModelAssignerModal && (
              <PrintModelAssigner
                onClose={() => setShowPrintModelAssignerModal(false)}
                zIndex={zIndices["printModelAssigner"]}
                onOpenDesigner={() => {
                  setShowPrintModelAssignerModal(false);
                  openInvoiceDesignerModal();
                }}
              />
            )}
          </div>
        </main>
      </div>

      <MarqueeNotice />
      <StatusBar />
    </div>
  );
}

export default HomePage;
